import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient instance with sensible defaults for the atEaseAI SaaS app.
 *
 * Defaults:
 * - staleTime: 30 seconds (data is fresh for 30s before background refetch)
 * - gcTime: 5 minutes (unused cache entries are garbage-collected after 5min)
 * - retry: 1 (retry failed queries once; auth errors are excluded via the hook)
 * - refetchOnWindowFocus: true (standard for dashboards)
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
